import Step from './step';
import {createElement} from 'methods/utils';
import EmailForgotStep from './email-forgot-step';
import EmailRegisterStep from './email-register-step';
import FormErrorsMixin from '../form-errors-mixin';

function EmailAuthStep(modal, options = {}) {
    const className = 'EmailAuthStep';
    const $element = createElement(
        `<div class="${className}">
            <div class="${className}__wrapper">
                <form action="/users_v2/authorization/" method="POST">
                    <div class="${className}__input-block">
                        <label class="${className}__input-label">Введите адрес электронной почты</label>
                        <div class="${className}__input-wrapper">
                            <input class="${className}__input" type="email" name="email">
                        </div>
                    </div>
                    <div class="${className}__input-block">
                        <label class="${className}__input-label">Введите пароль</label>
                        <div class="${className}__input-wrapper">
                            <input class="${className}__input" type="password" name="password">
                            <div class="${className}__password-reveal js-password-reveal">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 5C7.79667 5 3.98486 7.27968 1.17214 10.9825C0.94262 11.2859 0.94262 11.7097 1.17214 12.013C3.98486 15.7203 7.79667 18 12 18C16.2033 18 20.0151 15.7203 22.8279 12.0175C23.0574 11.7141 23.0574 11.2903 22.8279 10.987C20.0151 7.27968 16.2033 5 12 5ZM12.3015 16.0772C9.5113 16.2512 7.20712 13.9715 7.38263 11.2011C7.52664 8.91695 9.39429 7.06555 11.6985 6.92279C14.4887 6.7488 16.7929 9.02848 16.6174 11.7989C16.4689 14.0786 14.6012 15.93 12.3015 16.0772ZM12.162 13.9626C10.6589 14.0563 9.41679 12.8294 9.5158 11.3394C9.59231 10.1081 10.6004 9.11325 11.8425 9.03294C13.3456 8.93926 14.5877 10.1661 14.4887 11.6561C14.4077 12.8919 13.3996 13.8868 12.162 13.9626Z" fill="#2A2536"/>
                                </svg>
                            </div>
                        </div>
                        <div class="${className}__forgot-wrapper">
                            <div class="${className}__forgot js-forgot">Не помню пароль</div>
                        </div>
                    </div>
                    <button class="${className}__submit js-submit">Войти</button>
                    <div class="${className}__policy">
                        <p>Авторизуясь, вы соглашаетесь с правилами использования сервиса и обработки <a href="/about/guest_offer/">персональных данных</a>.</p>
                        <p><a href="https://privettur.ru/about/obrabotka_personalnyh_dannyh/" target="_blank">Политика в отношении обработки персональных данных</a></p>
                        <p><a href="https://privettur.ru/about/soglasie_na_obrabotku_personalnyh_dannyh/" target="_blank">Согласие на обработку персональных данных</a></p>
                    </div>
                </form>
            </div>
        </div>`
    );

    Step.call(this, modal, $element, options);
    FormErrorsMixin.call(this);

    this._authPromise = new Promise((resolve, reject) => {
        this._authPromiseResolve = resolve;
        this._authPromiseReject  = reject;
    });

    this.className = className;
    this.fieldsErorrs = [];

    this.$form = this.$element.querySelector('form');
    this.$form.addEventListener('submit', e => {
        e.preventDefault();
        this.submit();
    });

    this.$passwordReveal = this.$element.querySelector('.js-password-reveal');
    this.$passwordReveal.addEventListener('click', () => {
        this.$form.elements.password.type = this.$form.elements.password.type == 'password' ? 'text' : 'password';
        this.$passwordReveal.classList.toggle('is-active', this.$form.elements.password.type == 'text');
    });

    this.$forgot = this.$element.querySelector('.js-forgot');
    this.$forgot.addEventListener('click', () => {
        this.showStep(new EmailForgotStep(this.modal));
    });

    this.$submit = this.$element.querySelector('.js-submit');
}

EmailAuthStep.prototype = Object.create(Step.prototype);
Object.assign(EmailAuthStep.prototype, FormErrorsMixin.prototype);
Object.defineProperty(EmailAuthStep.prototype, 'constructor', {
    value: EmailAuthStep,
    enumerable: false,
    writable: true,
});

EmailAuthStep.prototype.auth = function() {
    return this._authPromise;
}

EmailAuthStep.prototype.submit = function() {
    const formData = new FormData(this.$form);

    this.$submit.classList.add('is-loading');
    this.resetFieldsErrors();

    return fetch(this.$form.action, {
        method: this.$form.method,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            this.showFieldsErrors(r.fields);
            return;
        }

        this._authPromiseResolve(r.data);
    }).finally(() => {
        this.$submit.classList.remove('is-loading');
    });
}

EmailAuthStep.prototype.show = function() {
    this.modal.setTitle('Вход в личный кабинет');
    this.modal.setCanPrevStep(true);

    const $footer = createElement(
        `<div class="${this.className}__register">
            У вас ещё нет аккаунта? <a href="javascript:void(0);" class="js-register">Зарегистрироваться</a>
        </div>`
    );

    const $register = $footer.querySelector('.js-register');
    $register.addEventListener('click', e => {
        if (typeof this.emailRegisterStep == 'undefined') {
            this.emailRegisterStep = new EmailRegisterStep(this.modal);
        }
        this.showStep(this.emailRegisterStep);
    });

    this.modal.setFooterContent($footer);
}

export default EmailAuthStep;
